import m from "./../../../dist/es2015/locales/de_DE.js";
export const am5locales_de_DE = m;